import { useQuery } from '@tanstack/react-query';
import { api, GuildTreasuryResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseGuildTreasuryOptions {
  /** Only fetch when the guild is an earning guild and user is a member */
  enabled?: boolean;
}

interface UseGuildTreasuryReturn {
  treasury: GuildTreasuryResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useGuildTreasury(
  guildId: string | undefined,
  options?: UseGuildTreasuryOptions,
): UseGuildTreasuryReturn {
  const enabled = (options?.enabled ?? true) && !!guildId;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.guilds.treasury(guildId!),
    queryFn: () => api.getGuildTreasury(guildId!),
    enabled,
  });

  return {
    treasury: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load treasury' : null,
    refresh: () => {
      refetch();
    },
  };
}
